import { render, staticRenderFns } from "./p_invest021.vue?vue&type=template&id=0096bdb5&scoped=true&"
import script from "./p_invest021.vue?vue&type=script&lang=js&"
export * from "./p_invest021.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0096bdb5",
  null
  
)

export default component.exports